export function setCoachingBlocks(state, coachingBlocks) {
    state.coachingBlocks = []

    coachingBlocks.forEach(function(coachingBlock) {
        coachingBlock.selected = false
        state.coachingBlocks.push(coachingBlock)
    })

    if (state.coachingBlocks.length)
        state.coachingBlocks[0].selected = true
}

export function setUpcomingEvent(state, coachingTrack) {
    state.upcomingEvent = coachingTrack
}


export function setActiveTimezone(state, timezone) {
    state.activeTimezone = timezone
}

export function setLastUpdated(state) {
    state.lastUpdated = new Date().getTime()
}

export function setDefaultActiveCoachingblock(state) {
    if (state.activeCoachingblockId)
        state.activeCoachingblock = state.coachingBlocks.find(cb => cb._id == state.activeCoachingblockId)
}

export function setActiveCoachingblock(state, _id) {
    state.activeCoachingblock = state.coachingBlocks.find(cb => cb._id == _id)
    state.activeCoachingblockId = state.activeCoachingblock._id
}

export function resetStore(state) {
    state.coachingBlocks = []
    state.activeCoachingblock = null
    state.activeCoachingblockId = null
    state.activeTimezone = ""
    state.lastUpdated = null
    state.scroll = null
}
